/**
 * Zentrale Benachrichtigungsfunktion – ersetzt createToast und direkte Swal.fire Aufrufe.
 *
 * Typen:
 *   'success' – grüner Toast unten rechts (auto-dismiss nach 2.5s)
 *   'error'   – roter Toast unten rechts (bleibt, bis geschlossen)
 *   'info'    – blauer Toast unten rechts (auto-dismiss nach 2.5s)
 *   'warning' – gelber Toast unten rechts (auto-dismiss nach 3s)
 *   'confirm' – blockierender Dialog (gibt Promise<boolean> zurück)
 *
 * @param {'success'|'error'|'info'|'warning'|'confirm'} type
 * @param {string} message
 * @param {string} [title]
 * @returns {Promise<boolean>|void}
 */
export function notify(type, message, title, options = {}) {
  const Swal = window.Swal ?? window.cs?.Swal;

  if (!Swal) {
    // Fallback wenn SweetAlert2 noch nicht geladen
    console.warn(`[notify] SweetAlert2 not available. [${type}] ${title ?? ""}: ${message}`);
    return Promise.resolve(true);
  }

  if (type === "confirm") {
    return Swal.fire({
      icon: options.icon ?? "warning",
      title: title ?? "Bist du sicher?",
      text: message,
      showCancelButton: true,
      confirmButtonText: options.confirmButtonText ?? "Ja",
      cancelButtonText: options.cancelButtonText ?? "Abbrechen",
      customClass: options.customClass ?? {
        confirmButton: "btn btn-danger me-3",
        cancelButton: "btn btn-secondary",
      },
      buttonsStyling: false,
      ...options,
    }).then((result) => result.isConfirmed);
  }

  const timerByType = { success: 4000, info: 4000, warning: 4000, error: false };
  const timer = timerByType[type];

  return Swal.fire({
    icon: type,
    title: title ?? undefined,
    text: message,
    timer: timer || undefined,
    timerProgressBar: !!timer,
    ...options,
  });
}

/**
 * Kurzform-Helfer
 */
export const notifySuccess = (message, title, options) =>
  notify("success", message, title, options);
export const notifyError = (message, title, options) => notify("error", message, title, options);
export const notifyInfo = (message, title, options) => notify("info", message, title, options);
export const notifyWarning = (message, title, options) =>
  notify("warning", message, title, options);
export const notifyConfirm = (message, title, options) =>
  notify("confirm", message, title, options);
